import { useCallback, useState } from 'react'
import { loadResultsDetails } from 'workflow/Workflow.actions'

import { useDocumentTitle } from 'common/hooks/custom'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import MainContent from 'features/unifiedFlow/components/MainContent'

import { getIsOptimized } from '../helpers'
import { useSelectedComponentElement } from '../hooks'

import useElementState from './hooks/useElementState'
import InputResultModal from './inputResult/InputResultModal'
import CenterSection from './centerSection'
import LeftSection from './leftSection'
import RightSection from './rightSection'

const Results = () => {
  useDocumentTitle('Results | Jacquard')
  const { isElementReady } = useElementState()

  const dispatch = useAppDispatch()

  const [isInputResultModalOpen, setIsInputResultModalOpen] = useState(false)

  const selectedElementId = useAppSelector(
    (state) => state.unifiedFlow.selectedElementId
  )
  const { data: selectedElement } = useSelectedComponentElement()
  const isOptimized = getIsOptimized(selectedElement)

  const handleSubmitInputResults = useCallback(() => {
    if (isOptimized && selectedElement?.campaign_id) {
      setIsInputResultModalOpen(false)
      dispatch(loadResultsDetails(selectedElement?.campaign_id))
    }
  }, [isOptimized, selectedElement?.campaign_id, dispatch])

  return (
    <MainContent id="main-content-page">
      <LeftSection />
      {!!selectedElementId && isElementReady && (
        <>
          <CenterSection />
          {isOptimized && (
            <RightSection
              onInputResultsClick={() => setIsInputResultModalOpen(true)}
            />
          )}
        </>
      )}
      {isOptimized && (
        // InputResultsModal is memoized, use only functions with callbacks
        <InputResultModal
          isOpen={isInputResultModalOpen}
          onClose={() => setIsInputResultModalOpen(false)}
          onSubmit={handleSubmitInputResults}
        />
      )}
    </MainContent>
  )
}

export default Results
